import React from "react";
import ReactMarkdown from "react-markdown";
import { withSafeMarkdownUrls } from "src/Ateam-BI/utils/safeMarkdown";

/**
 * Renders admin-authored Markdown (FAQ answers, etc.). react-markdown does not
 * render raw HTML by default, so untrusted markup is safe. Links open in a new
 * tab; links and images to non-Amazon hosts are shown as text.
 */
const MARKDOWN_COMPONENTS = withSafeMarkdownUrls({
  a: ({ node, ...props }) => (
    <a {...props} target="_blank" rel="noopener noreferrer" />
  ),
});

const MarkdownView = ({ children }) => {
  if (!children) return null;
  return (
    <div className="raise-markdown">
      <ReactMarkdown
        components={MARKDOWN_COMPONENTS}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownView;
